import { createContext } from 'react';

type MultipleIDsContextProps = {
  selectedIds: string[];
  manageId: (selectedId: string) => void;
  clearIds: () => void;
};

export default createContext<Partial<MultipleIDsContextProps>>({});
